import L from "leaflet";

export class GeoUtils {
    static calculateDistanceByPoints(pts) {
        pts = (pts || []).map(GeoUtils.toPoint);

        let distance = 0;
        for (let i = 1; i < pts.length; i++) {
            distance += GeoUtils.calculateDistance(pts[i - 1].lat, pts[i - 1].lon, pts[i].lat, pts[i].lon);
        }
        
        return distance;
    }

    static calculateDistance(lat1, lon1, lat2, lon2) {

        const R = 6371000;
        const dLat = this.toRadians(lat2 - lat1);
        const dLon = this.toRadians(lon2 - lon1);

        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return R * c;
    }

    static toRadians(degrees) {
        return degrees * Math.PI / 180;
    }

    static isSamePoint(p1, p2) {
        if (!p1 || !p2) return false;

        const d = this.calculateDistance(p1.lat, p1.lon, p2.lat, p2.lon);

        return d < 1;
    }

    static toLatLng(p) {
        if (!p) return p;
        if (p.lng !== undefined) return p;
        return L.latLng(p.lat, p.lon);
    }
    
    static toPoint(p) {
        if (!p) return p;
        if (p.lon !== undefined) return p;
        return { lat: p.lat, lon: p.lng };
    }

    static normalizedLon(lon) {
        while (lon >= 180) {
            lon -= 360;
        }

        while (lon < -180) {
            lon += 360;
        }

        return lon;
    }
    
    static normalizedPoint(p) {
        if (!p) return p;
        const result = {lat: p.lat, lon: p.lng || p.lon };
        result.lon = this.normalizedLon(result.lon);
        return result;
    }

    static normalizedLatLng(p) {
        if (!p) return p;
        const point = this.normalizedPoint(p);
        return L.latLng(point.lat, point.lon);
    }

    static isCrossingDateLine(p1, p2) {
        if (!p1 || !p2) return false;

        const lon1 = this.normalizedPoint(p1).lon;
        const lon2 = this.normalizedPoint(p2).lon;

        return (lon1 * lon2 < 0) && (Math.abs(lon1 - lon2) > 180);
    }

    static toContinuousPoints(points) {
        if (points || !points.length) return points;

        const result = [points[0]];
    
        for (let i = 1; i < points.length; i++) {
            const prevPoint = result.at(-1);
            if (GeoUtils.isCrossingDateLine(prevPoint, points[i])) {
                console.log('Crossing', prevPoint, points[i]);
                result.push(points[i]);
            }
            else {
                result.push(points[i]);
            }
        }

        return result;
    }

    static toPointHemisphere(points, latLng) {
        const p = { lat: latLng.lat, lon: latLng.lng || latLng.lon };

        const over180 = points.some(p => p.lon > 180);
        const under180 = points.some(p => p.lon <= -180);

        if (over180) {
            if (p.lon < 0) {
                p.lon += 360;
            }
        }
        else if (under180) {
            if (p.lon > 0) {
                p.lon -= 360;
            }
        }
        else {
            if (points.every(p => p.lon > 0) && p.lon <= -180) {
                p.lon += 360;
            }
            else if (points.every(p => p.lon < 0) && p.lon > 180) {
                p.lon -= 360;
            }
        }

        return p;
    }    

    static defaultOffsets = [-360, 0, 360];
    static offsetPoints(points, offsets) {
        if (!points) return points;

        if (!offsets)
            offsets = this.defaultOffsets;

        return offsets.map(offset => {
            return points.map(p => {
                if (p.lng) {
                    return L.latLng(p.lat, p.lng + offset);
                }
                else {
                    return {
                        ...p,
                        lon: p.lon + offset
                    }
                }
            })
        });
    }
    
    static isPointInsideZone(point, restrictedZones) {
        if (!point) return false;
        if (!restrictedZones || !restrictedZones.length) return false;

        point = this.normalizedPoint(point);

        const offsetPoints = this.offsetPoints([point]);

        return offsetPoints.some(points => {
            return points.some(p => {
                return (restrictedZones || []).some(z => {
                    return p.lat <= z.north && p.lat >= z.south && p.lon <= z.east && p.lon >= z.west; 
                })
            });
        });
    }
}
